import useSWR from "swr";
import { API_BASE_URL } from "@/lib/env";
import type { APIPodcast } from "@/api/client";

export interface Podcast {
  id: string;
  name: string;
  emoji: string;
  episodeCount?: number;
  taxonomy?: {
    Format?: string[];
    Theme?: string[];
    Topic?: string[];
  } | null;
}

export function usePodcasts() {
  const { data, error, isLoading, mutate } = useSWR<APIPodcast[]>(
    `${API_BASE_URL}/me/podcasts`,
  );

  // Normalize to app's Podcast type
  const podcasts: Podcast[] = (data ?? []).map((p) => ({
    id: p.podcast_slug,
    name: p.display_name,
    emoji: p.emoji || "🎧",
    episodeCount: p.episode_count,
    taxonomy: p.taxonomy,
  }));

  return {
    podcasts,
    isLoading,
    isError: !!error,
    refreshPodcasts: mutate,
  };
}
